'use client';

import { BottomDrawer, Button } from '@common/components';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import {
  AuthQueryOptions,
  BANNER_CONTENTS_TYPE,
  UnauthQueryOptions,
} from '@/api';
import { Image } from '@/components/client';
import { SELECTOR, STORAGE_KEY } from '@/constants';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { useAuthStore } from '@/stores/AuthStore';

export const HometownNewsDetailBottomDrawer = () => {
  const [isShow, setIsShow] = useState(false);
  const { isWelloApp } = useCheckWelloApp();
  const isLogin = useAuthStore((state) => state.isLogin);
  const { entry } = useWebviewTypeEntry();

  const { data, isLoading } = useQuery(
    isLogin
      ? {
          ...AuthQueryOptions['get:/wello/v2/auth/banner']({
            query: {
              contentsTypeCd: BANNER_CONTENTS_TYPE.HOMETOWN_BOTTOM_SHEET,
            },
          }),
        }
      : {
          ...UnauthQueryOptions['get:/wello/v2/allows/banner']({
            query: {
              contentsTypeCd: BANNER_CONTENTS_TYPE.HOMETOWN_BOTTOM_SHEET,
              entry,
            },
          }),
        },
  );

  const banner = (data?.context?.contents ?? [])[0];

  const applyFileUrl = isWelloApp ? banner?.appFileUrl : banner?.fileUrl;
  const applyLinkUrl = isWelloApp ? banner?.appLinkUrl : banner?.linkUrl;

  useEffect(() => {
    if (!window || !sessionStorage) return;

    const bottomDrawerShowPathname = sessionStorage.getItem(
      STORAGE_KEY.HOMETOWN_NEWS_DETAIL_BOTTOM_DRAWER_PATH,
    );

    setTimeout(() => {
      setIsShow(bottomDrawerShowPathname === window.location.pathname);
      sessionStorage.removeItem(
        STORAGE_KEY.HOMETOWN_NEWS_DETAIL_BOTTOM_DRAWER_PATH,
      );
    }, 2000);
  }, []);

  const handleClick = () => {
    if (!applyLinkUrl) return;
    window.location.href = applyLinkUrl;
  };
  const handleClose = () => {
    setIsShow(false);
  };

  const isNoRender =
    !!isLogin || (!isLoading && !banner) || !(applyFileUrl && applyLinkUrl);

  if (isNoRender) return null;

  return (
    <BottomDrawer
      opened={isShow}
      renderTo={() => document.getElementById(SELECTOR.MAIN_WRAPPER)}
      onClose={handleClose}
    >
      <BottomDrawer.HandleWrapper>
        <BottomDrawer.Handle />
      </BottomDrawer.HandleWrapper>
      <BottomDrawer.Contents className="mx-0 flex flex-col justify-between">
        <section className="flex flex-col items-center gap-28 px-48 py-5 pb-16">
          <section className="flex flex-col items-center gap-4 text-center">
            <p className="whitespace-pre-wrap font-700 text-Gray-900 typo-body1">
              {banner.title}
            </p>
            <p className="whitespace-pre-wrap font-400 text-Gray-700 typo-body4">
              {banner.subtitle}
            </p>
          </section>

          <Image
            alt="배너 이미지"
            className="rounded-xsmall"
            src={applyFileUrl}
            width={280}
            height={275}
          />
        </section>
        <section className="px-20 py-16 flex-center">
          <Button
            className="w-full whitespace-pre-wrap px-0 py-16"
            theme="primary-fill"
            onClick={handleClick}
          >
            {banner.buttonText}
          </Button>
        </section>
      </BottomDrawer.Contents>
    </BottomDrawer>
  );
};
